import React from 'react';
import { FileDown, FileText } from 'lucide-react';
import { utils, writeFile } from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const ExportButton = ({ data, columns, fileName = 'export', title = 'Report' }) => {

    const handleExportExcel = () => {
        const sheetData = data.map(item => {
            const row = {};
            columns.forEach(col => {
                row[col.header] = col.accessor(item);
            });
            return row;
        });

        const wb = utils.book_new();
        const ws = utils.json_to_sheet(sheetData);
        utils.book_append_sheet(wb, ws, "Sheet1");
        writeFile(wb, `${fileName}.xlsx`);
    };

    const handleExportPDF = () => {
        const doc = new jsPDF();
        doc.text(title, 14, 15);

        const tableColumn = columns.map(col => col.header);
        const tableRows = data.map(item => {
            return columns.map(col => col.accessor(item));
        });

        doc.autoTable({
            head: [tableColumn],
            body: tableRows,
            startY: 20,
        });

        doc.save(`${fileName}.pdf`);
    };

    return (
        <div className="flex gap-2">
            <button
                onClick={handleExportExcel}
                className="btn btn-secondary flex items-center gap-1 text-sm bg-green-50 text-green-700 border-green-200 hover:bg-green-100"
                style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #e2e8f0', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', background: 'white' }}
                title="Export to Excel"
            >
                <FileDown size={16} /> Excel
            </button>
            <button
                onClick={handleExportPDF}
                className="btn btn-secondary flex items-center gap-1 text-sm bg-red-50 text-red-700 border-red-200 hover:bg-red-100"
                style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #e2e8f0', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', background: 'white' }}
                title="Export to PDF"
            >
                <FileText size={16} /> PDF
            </button>
        </div>
    );
};

export default ExportButton;
